

export function LegalMention() {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', marginBottom: 150}}>
            <h1 style={{ fontFamily: 'Nickainley', color: '#7E649D', fontWeight: 'normal', fontSize: '24px', marginTop: '2%' }}>Mentions légales</h1>
            <div style={{ width: '50%', textAlign: 'left', marginLeft: '25%', marginTop: '2%' }}>
                <p style={{fontFamily:'Poiret', fontWeight:'bold'}}>
                    Cousu Mouche est une marque déposée et protégée auprès de l’INPI.
                    <br /><br />
                    L’entreprise est créée par Mme SARIKAYA DONFUT Perrine – créatrice commerçante d’articles textiles et accessoires destinés aux bébés et aux parents.
                    <br /><br />
                    Statut : auto-entrepreneur, forme juridique micro-entreprise.
                    <br /><br />
                    Adresse : 9, Avenue du Mauzac, 11300 Saint-Polycarpe, France.
                    <br /><br />
                    Courriel : contact@cousumouche.fr
                    <br /><br />
                    L’entreprise est inscrite à la Chambre de Métiers et de l’Artisanat de l’Aude sous le numéro SIRET : 90009072100011 et immatriculée au Répertoire des Métiers sous le numéro : 900.090.721 RM 11.
                    <br /><br />
                    Les prix sont nets TTC, TVA non applicable, article 293B du CGI.
                    <br /><br />
                    Le site internet est développé par Mr SARIKAYA Sevan, responsable de publication et est hébergé sur (adresse et numéro de tél)
                    <br /><br />
                    L’entièreté du site est la propriété de la créatrice et du développeur : Mr et Mme Sarikaya
                </p>
            </div>
        </div>
    )
}